/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrderOrigin } from './OrderOrigin';
import {
    OrderOriginFromJSON,
    OrderOriginFromJSONTyped,
    OrderOriginToJSON,
    OrderOriginToJSONTyped,
} from './OrderOrigin';
import type { OrderType } from './OrderType';
import {
    OrderTypeFromJSON,
    OrderTypeFromJSONTyped,
    OrderTypeToJSON,
    OrderTypeToJSONTyped,
} from './OrderType';
import type { HeoItemId } from './HeoItemId';
import {
    HeoItemIdFromJSON,
    HeoItemIdFromJSONTyped,
    HeoItemIdToJSON,
    HeoItemIdToJSONTyped,
} from './HeoItemId';
import type { HeoCustomerOrderNumber } from './HeoCustomerOrderNumber';
import {
    HeoCustomerOrderNumberFromJSON,
    HeoCustomerOrderNumberFromJSONTyped,
    HeoCustomerOrderNumberToJSON,
    HeoCustomerOrderNumberToJSONTyped,
} from './HeoCustomerOrderNumber';

/**
 * 
 * @export
 * @interface CustomerOrderItemSummary
 */
export interface CustomerOrderItemSummary {
    /**
     * 
     * @type {HeoItemId}
     * @memberof CustomerOrderItemSummary
     */
    heoItemId: HeoItemId;
    /**
     * 
     * @type {number}
     * @memberof CustomerOrderItemSummary
     */
    quantity: number;
    /**
     * 
     * @type {number}
     * @memberof CustomerOrderItemSummary
     */
    acceptedQuantity: number;
    /**
     * 
     * @type {number}
     * @memberof CustomerOrderItemSummary
     */
    pricePerUnit: number;
    /**
     * 
     * @type {number}
     * @memberof CustomerOrderItemSummary
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof CustomerOrderItemSummary
     */
    discount: number;
    /**
     * 
     * @type {string}
     * @memberof CustomerOrderItemSummary
     */
    customerItemReference: string;
    /**
     * 
     * @type {CustomerOrderItemSummaryStatusEnum}
     * @memberof CustomerOrderItemSummary
     */
    status: CustomerOrderItemSummaryStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof CustomerOrderItemSummary
     */
    productNumber: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerOrderItemSummary
     */
    customerOrderId: string;
    /**
     * 
     * @type {HeoCustomerOrderNumber}
     * @memberof CustomerOrderItemSummary
     */
    customerOrderNumber: HeoCustomerOrderNumber;
    /**
     * 
     * @type {string}
     * @memberof CustomerOrderItemSummary
     */
    customerOrderCustomerReference: string;
    /**
     * 
     * @type {Date}
     * @memberof CustomerOrderItemSummary
     */
    customerOrderCreatedAt: Date;
    /**
     * 
     * @type {OrderOrigin}
     * @memberof CustomerOrderItemSummary
     */
    orderOrigin?: OrderOrigin;
    /**
     * 
     * @type {OrderType}
     * @memberof CustomerOrderItemSummary
     */
    orderType?: OrderType;
}


/**
 * @export
 */
export const CustomerOrderItemSummaryStatusEnum = {
    Unconfirmed: 'UNCONFIRMED',
    Confirmed: 'CONFIRMED',
    Other: 'OTHER'
} as const;
export type CustomerOrderItemSummaryStatusEnum = typeof CustomerOrderItemSummaryStatusEnum[keyof typeof CustomerOrderItemSummaryStatusEnum];


/**
 * Check if a given object implements the CustomerOrderItemSummary interface.
 */
export function instanceOfCustomerOrderItemSummary(value: object): value is CustomerOrderItemSummary {
    if (!('heoItemId' in value) || value['heoItemId'] === undefined) return false;
    if (!('quantity' in value) || value['quantity'] === undefined) return false;
    if (!('acceptedQuantity' in value) || value['acceptedQuantity'] === undefined) return false;
    if (!('pricePerUnit' in value) || value['pricePerUnit'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('discount' in value) || value['discount'] === undefined) return false;
    if (!('customerItemReference' in value) || value['customerItemReference'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('productNumber' in value) || value['productNumber'] === undefined) return false;
    if (!('customerOrderId' in value) || value['customerOrderId'] === undefined) return false;
    if (!('customerOrderNumber' in value) || value['customerOrderNumber'] === undefined) return false;
    if (!('customerOrderCustomerReference' in value) || value['customerOrderCustomerReference'] === undefined) return false;
    if (!('customerOrderCreatedAt' in value) || value['customerOrderCreatedAt'] === undefined) return false;
    return true;
}

export function CustomerOrderItemSummaryFromJSON(json: any): CustomerOrderItemSummary {
    return CustomerOrderItemSummaryFromJSONTyped(json, false);
}

export function CustomerOrderItemSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomerOrderItemSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'heoItemId': HeoItemIdFromJSON(json['heoItemId']),
        'quantity': json['quantity'],
        'acceptedQuantity': json['acceptedQuantity'],
        'pricePerUnit': json['pricePerUnit'],
        'total': json['total'],
        'discount': json['discount'],
        'customerItemReference': json['customerItemReference'],
        'status': json['status'],
        'productNumber': json['productNumber'],
        'customerOrderId': json['customerOrderId'],
        'customerOrderNumber': HeoCustomerOrderNumberFromJSON(json['customerOrderNumber']),
        'customerOrderCustomerReference': json['customerOrderCustomerReference'],
        'customerOrderCreatedAt': (new Date(json['customerOrderCreatedAt'])),
        'orderOrigin': json['orderOrigin'] == null ? undefined : OrderOriginFromJSON(json['orderOrigin']),
        'orderType': json['orderType'] == null ? undefined : OrderTypeFromJSON(json['orderType']),
    };
}

export function CustomerOrderItemSummaryToJSON(json: any): CustomerOrderItemSummary {
    return CustomerOrderItemSummaryToJSONTyped(json, false);
}

export function CustomerOrderItemSummaryToJSONTyped(value?: CustomerOrderItemSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'heoItemId': HeoItemIdToJSON(value['heoItemId']),
        'quantity': value['quantity'],
        'acceptedQuantity': value['acceptedQuantity'],
        'pricePerUnit': value['pricePerUnit'],
        'total': value['total'],
        'discount': value['discount'],
        'customerItemReference': value['customerItemReference'],
        'status': value['status'],
        'productNumber': value['productNumber'],
        'customerOrderId': value['customerOrderId'],
        'customerOrderNumber': HeoCustomerOrderNumberToJSON(value['customerOrderNumber']),
        'customerOrderCustomerReference': value['customerOrderCustomerReference'],
        'customerOrderCreatedAt': value['customerOrderCreatedAt'].toISOString(),
        'orderOrigin': OrderOriginToJSON(value['orderOrigin']),
        'orderType': OrderTypeToJSON(value['orderType']),
    };
}

